module.exports = __webpack_public_path__ + "catalog/items/bathroom/corner_shower/corner-shower.svg";